import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import { Form, Formik } from "formik";
import api from "../../../../../API";
import { useSelector } from "react-redux";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import { useNavigate } from "react-router-dom";
import { GridFooterContainer } from "@mui/x-data-grid";
import CustomPagination from "../../../../component/common/CustomPagination";


interface pageInfoType {
  current_page: number;
  total_pages: number;
  total_count: number;
}

interface KiStc{
  did: string;
  keyword: string;
  sid: string;
  stext: string;
  title_sub: string;
  tkn_num: number;
}


// const SampleRejectRsnDialog = () => {
const FixDataForTtaListDialog = (props: any) => {

  const nav = useNavigate();

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const dragRef = useRef<HTMLLabelElement | null>(null);
  const fileId = useRef<number>(0);

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const [datas, setDatas] = useState([]);

  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const getFixDataForTtaList = async () => {

    // if(['구명훈', '전가람'].includes(email)){
    
    // var result = await api.get("/fixDataForTtaListCheck200", {
    //   params: {email:email}
    // });

    // }else{
    //   var result = await api.get("/fixDataForTtaList", {
    //     params: {email:email}
    //   });
    // }
    var result = await api.get("/fixDataForTtaList", {
      params: {email:email}
    });

    // console.log('리턴 데이터 ' , result.data.datas)
    var datas = result.data.datas
    setDatas(datas);
    setPagination(result.data.pagination);

    // console.log('result.data.datas[0]',result.data.datas[0])
    detailInfo(result.data.datas[0])
    
  }


  const [didInfo, setDidInfo] = useState<any>(null);
  const [clickDid, setClickDid] = useState("");
  const [clickTitle, setClickTitle] = useState("");
  const [kiStc, setKiStc] = useState<KiStc[]>([]);

  const getKiDoc = async (did:string) => {
    // console.log('did 다시 인트형으로',parseInt(did, 10),"/getKiDoc?did="+parseInt(did, 10))
    var result = await api.get("/getKiDoc?did="+parseInt(did, 10))
    .then(response => {
      // console.log('getKiDoc 정보', response.data.datas)
      const res = response.data.datas
      console.log('getKiDoc res',res)
      if(res.length > 0){
        console.log('ki_stc 정보 ?? ' , res[0].ki_stc)
        setKiStc(res[0].ki_stc)
      }
      // setKiDoc(response.data.datas)
    });

  }

  const [qaList, setQaList] = useState([]);
  const [clickMgm_pk, setClickMgm_pk] = useState("");

  const [p_gub_nam, setP_gub_nam] = useState('')
  const [p_sub_gub_nam, setP_sub_gub_nam] = useState('')
  const [sidList, setSidList] = useState<any>([])
  // const [kiStcFilter, setKiStcFilter] = useState<any>([])

  const [topicCodeList, setTopicCodeList] = useState<any>([])

  // const getTopicCodeList = async () => {
  //   var result = await api.get("/getToopicCodeList")
  //   .then(response => {
  //     // console.log('getQAList 정보', response.data.datas)
  //     const res = response.data.datas
  //     setTopicCodeList(res)
  //     console.log('코드리스트 ::: ' , setTopicCodeList)
  //     // const sidArray = res.map((obj:any) => obj.sid);
  //     // console.log('줄수 불러오기 ::: ' , sidArray)
  //     // setSidList(sidArray)

  //   });

  // }


  const getQAList = async (mgm_pk:string) => {
    setClickMgm_pk(mgm_pk)
    // console.log('did 다시 인트형으로',parseInt(did, 10),"/getKiDoc?did="+parseInt(did, 10))
    var result = await api.get("/getQAList",{params: {email:email, mgm_pk:mgm_pk}})
    .then(response => {
      // console.log('getQAList 정보', response.data.datas)
      const res = response.data.datas
      setQaList(res)
      console.log('질문답변 값 ::: ' , res)
      const sidArray = res.map((obj:any) => obj.sid);
      console.log('줄수 불러오기 ::: ' , sidArray)
      setSidList(sidArray)

    });

  }

  const detailInfo = (data:any) => {
    if(data.length === 0){
      alert('작업종료')
    }

    if(clickDid == data.did){
      // console.log('클릭 해제')
      setClickDid("")
    }
    else{
      // setKiStcFilter([])
      setKiStc([])
      setQaList([])
      changeDid(data)
      // console.log('초기화 값' , data.gub_nam, data.sub_gub_nam)
    }
    
  }

  const changeDid = (data:any) => {
    console.log('바뀐 data' , data)
    setClickDid(data.did)
    setClickTitle(data.title)
    // getTopicCodeList()
    getKiDoc(data.did)
    getQAList(data.mgm_pk); 
    setDidInfo(data); 
    setP_gub_nam(data.gub_nam);
    setP_sub_gub_nam(data.sub_gub_nam)
  }

  useEffect(() => {
    getFixDataForTtaList()
  }, []);

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  

  useEffect(() => {
    // 키보드 이벤트 리스너 추가
    const handleKeyPress = (event:any) => {
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault(); // 브라우저의 기본 동작을 방지
        // console.log('업데이트 진행 준비' , p_gub_nam , p_sub_gub_nam)
        saveGub();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [p_gub_nam , p_sub_gub_nam]);

  const saveGub = async () => {
    // console.log('업데이트 진행합니다' , p_gub_nam , p_sub_gub_nam)

    const formData = new FormData();
    
    formData.append("email", email);
    formData.append("did", clickDid);
    formData.append("mgm_pk", clickMgm_pk);
    formData.append("p_gub_nam", p_gub_nam);
    formData.append("p_sub_gub_nam", p_sub_gub_nam);

    
    // await api.post("/updateWikiTitle",formData)
    //   .then((res:any) => {alert('업데이트 완료'); getFixDataForTtaList()})
    //   .catch((error:any) => {alert(error.response.data.error);})

    await api.post("/updateWikiTitle",formData)
    .then((res:any) => { alert("업데이트 완료"); getFixDataForTtaList(); })
    .catch((error:any) => {console.log('오류오류 ::: ' , error); alert('오류 - '+ error.response.data.error);})
  }


  
  return (
    <Box >
    <Dialog fullScreen open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>대분류 소분류 수정 (TTA)</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
          <Box sx={{height:"100%"}} display="flex">
            <Box sx={{borderRight: "dashed", width:"430px"}}>
              <Box sx={{fontSize:"24px", marginBottom:"12px"}}>할당 리스트 <b style={{color:"blue"}}>{pagination? pagination.total_count : 0}</b> 건</Box>
              <Box sx={{height:"660px", overflow: "auto", border:"2px solid #000"}}>
                {datas.length > 0 && datas.map((data:any,idx:any) => 
                  <Box display="flex" key={data.did + idx}>
                    <Box sx={{width:"100%", cursor:"pointer", padding:"2px", margin:"6px 0px 0px 12px", color:(clickDid == data.did ? "#fff" : "#000"), backgroundColor:(clickDid == data.did ? "blue" : "#fff")}} onClick={()=>{detailInfo(data); }}>{data.did}</Box>
                  </Box>
                )}
              </Box>
              <Box sx={{marginTop:"12px"}}>
                {pagination !== undefined ? (
                    <CustomPagination pagination={pagination} goPage={goPage} />
                ) : ""}
              </Box>
            </Box>
            <Box sx={{padding:"12px"}}>
                {clickDid && qaList && (
                  <>
                    <Box display="flex">
                      <Box display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"20px",fontWeight:700}}>TITLE</Box>
                          <Box sx={{fontSize:"20px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {clickTitle}
                        </Box>
                        <Box sx={{fontSize:"20px",fontWeight:700}}>DID</Box>
                        <Box sx={{fontSize:"20px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        {clickDid}
                        </Box>
                        <Box sx={{fontSize:"20px",fontWeight:700}}>MGM_PK</Box>
                        <Box sx={{fontSize:"20px", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          {clickMgm_pk}
                        </Box>
                      </Box>
                    </Box>
                    
                    {didInfo &&
                      (<Box display="flex">
                        <Box sx={{padding:"16px"}}>
                          <Box display="flex">
                            <Box sx={{fontSize:"20px",marginTop:"4px"}}>기존 대분류 : </Box>
                            <Box>
                              {/* {didInfo.origin_gub_nam} */}
                              <Select id="didInfo.origin_gub_nam" value={didInfo.origin_gub_nam} sx={{color:"red",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                <MenuItem dense value={"경제및산업"}>01,경제및산업</MenuItem>
                                <MenuItem dense value={"사회및제도"}>02.사회및제도</MenuItem>
                                <MenuItem dense value={"문화및라이프"}>03.문화및라이프</MenuItem>
                                <MenuItem dense value={"게임및과학"}>04.게임및과학</MenuItem>
                                <MenuItem dense value={"건강및의학"}>05.건강및의학</MenuItem>
                                <MenuItem dense value={"언론및보도"}>06.언론및보도</MenuItem>
                                <MenuItem dense value={"학문및원리"}>07.학문및원리</MenuItem>
                                <MenuItem dense value={"역사및지리"}>08.역사및지리</MenuItem>
                                <MenuItem dense value={"자연및환경"}>09.자연및환경</MenuItem>
                                <MenuItem dense value={"종교및정치"}>10.종교및정치</MenuItem>
                              </Select>
                            </Box>
                          </Box>
                          <Box display="flex" sx={{marginTop:"8px"}}>
                            <Box sx={{fontSize:"20px",marginTop:"4px"}}>기존 소분류 : </Box>
                            <Box sx={{fontSize:"20px", color:"red", marginLeft:"8px",marginRight:"12px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              {didInfo.origin_sub_gub_nam}
                            </Box>
                          </Box>
                        </Box>

                        <Box sx={{padding:"16px"}}>
                          <Box display="flex">
                            <Box sx={{fontSize:"20px",marginTop:"4px"}}>업데이트 대분류 : </Box>
                            <Box>
                              <Select id="p_gub_nam" value={p_gub_nam} onChange={(e)=>{setP_gub_nam(e.target.value)}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                <MenuItem dense value={"경제및산업"}>01,경제및산업</MenuItem>
                                <MenuItem dense value={"사회및제도"}>02.사회및제도</MenuItem>
                                <MenuItem dense value={"문화및라이프"}>03.문화및라이프</MenuItem>
                                <MenuItem dense value={"게임및과학"}>04.게임및과학</MenuItem>
                                <MenuItem dense value={"건강및의학"}>05.건강및의학</MenuItem>
                                <MenuItem dense value={"언론및보도"}>06.언론및보도</MenuItem>
                                <MenuItem dense value={"학문및원리"}>07.학문및원리</MenuItem>
                                <MenuItem dense value={"역사및지리"}>08.역사및지리</MenuItem>
                                <MenuItem dense value={"자연및환경"}>09.자연및환경</MenuItem>
                                <MenuItem dense value={"종교및정치"}>10.종교및정치</MenuItem>
                              </Select>
                            </Box>
                          </Box>
                          <Box display="flex" sx={{marginTop:"8px"}}>
                            <Box sx={{fontSize:"20px",marginTop:"4px"}}>업데이트 소분류 : </Box>
                            <Box>
                              <TextField size="small" id="p_sub_gub_nam" value={p_sub_gub_nam} onChange={(e)=>{setP_sub_gub_nam(e.target.value)}} sx={{width:"150px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                                InputProps={{
                                  style: { height:"30px"},
                                }}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>)
                    }
                    
                    <Box sx={{height:"24px",fontSize:"20px",color:"#fff",marginRight:"12px",backgroundColor:"#000",padding:"2px",borderRadius:"5px"}}>
                      지식 정보
                    </Box>
                    {kiStc.length > 0 && kiStc.map((kistc:any, idx:number) => {
                      console.log('kistc',kistc)
                      console.log('sidList',kistc.sid,sidList)
                      if(sidList.includes(kistc.sid.toString())){
                        return (
                          <Box key={"kistc" + idx}>
                            <Box>
                              <Box sx={{fontWeight:"500", fontSize:"14px", padding:"4px"}} key={'kistc'+idx}> sid : {kistc.sid}  </Box>
                              <textarea style={{fontSize:"14px", padding:"8px", width:"1100px", height:"55px"}} readOnly defaultValue={kistc.stext} />
                            </Box>
                          </Box>
                        )
                      }

                      }
                    )}

                    <Box>
                      <Box sx={{height:"24px",fontSize:"20px",color:"#fff",marginRight:"12px",backgroundColor:"#498ad5",padding:"2px",borderRadius:"5px"}}>
                        질문 답변
                      </Box>
                    </Box>
                    {qaList.length > 0 && qaList.map((qainfo:any, idx:number) => 
                      {
                        // let qasid = qainfo.sid * 1
                        // if(kiStcFilter.length === 0){
                        //   setKiStcFilter(kiStc.filter((data:any) => (data.sid === qasid )))
                        // }
                        return (
                          <Box key={'qalist'+idx}>
                            <Box display="flex">
                              <Box sx={{width: "50px", textAlign: "center", alignSelf: "center", height: "28px", fontSize:"14px", padding:"8px", color:"#fff", backgroundColor:(qainfo.spk_gub === "Q" ? "#49d57f": "#e9884f" )}}><Box>{qainfo.spk_gub}</Box><Box>{"sid : "+qainfo.sid}</Box></Box>
                              <Box sx={{fontSize:"16px"}}>
                              <textarea style={{fontSize:"14px", padding:"8px",width:"1030px", height:"30px"}} readOnly defaultValue={qainfo.stt_con} />
                                {/* {qainfo.stt_con} */}
                              </Box>
                            </Box>
                          </Box>
                        )
                      }
                    )}


                    
                  </>
                )
                }

            </Box>

          </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" sx={{fontWeight:700, margin:"8px 16px"}}
            onClick={() => {
              saveGub()
            }}
          >
            저장(Ctrl+s)
        </Button>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            nav("/admin/hrm/scriptFileList");
          }}
        >
          취소
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default FixDataForTtaListDialog;
